stimulusApp.register(
  "favourite-button",
  class extends Stimulus.Controller {
    static targets = ["updateContent"]

    optimisticUpdate(event) {
      if (this.hasUpdateContentTarget) {
        this.element.replaceChildren(
          ...this.updateContentTarget.content.cloneNode(true).childNodes,
        )
      }
    }
  },
)
